import { render } from "./CardBorder.vue?vue&type=template&id=a90d96f4&ts=true"
import script from "./CardBorder.vue?vue&type=script&lang=ts"
export * from "./CardBorder.vue?vue&type=script&lang=ts"

import exportComponent from "/var/jenkins_home/workspace/ecpv-pipeline/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__